import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Zap, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import './PaymentSuccess.css';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { fetchUser } = useAuth();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    if (orderId) {
      checkPaymentStatus();
    } else {
      navigate('/topup');
    }
  }, [orderId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(`/api/payments/check-status/${orderId}`);
      setPayment(response.data);
      
      // Если платеж успешно завершен (или уже был завершен), обновляем баланс пользователя
      if (response.data.status === 'completed') {
        // Обновляем данные пользователя, включая баланс
        // Это важно, так как баланс мог быть обновлен на backend, но не на фронтенде
        await fetchUser();
      }
    } catch (error) {
      console.error('Error checking payment:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="payment-success-container">
        <div className="payment-success-card">
          <div className="spinner-large"></div>
          <p>Проверяем статус платежа...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <div className="success-icon">
          <CheckCircle size={64} />
        </div>

        <h1>Платеж выполнен!</h1>
        <p className="success-message">
          Токены успешно зачислены на ваш счет
        </p>

        {payment && (
          <div className="payment-details">
            <div className="detail-row">
              <span className="detail-label">Order ID:</span>
              <span className="detail-value">{payment.order_id || orderId}</span>
            </div>
            <div className="detail-row highlight">
              <Zap size={20} />
              <span className="detail-label">Начислено токенов:</span>
              <span className="detail-value bonus-value">
                {payment.bonuses_added || payment.bonuses_to_add || 0}
              </span>
            </div>
          </div>
        )}

        <button 
          className="continue-btn"
          onClick={() => navigate('/home')}
        >
          Вернуться на главную
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
}

export default PaymentSuccess;

